import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface MobileFeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

export function MobileFeatureCard({ icon: Icon, title, description }: MobileFeatureCardProps) {
  return (
    <Card className="p-4">
      <div className="flex items-start gap-3">
        <div className="bg-primary/10 p-2 rounded-lg">
          <Icon className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
        </div>
      </div>
    </Card>
  );
}
